import { useQuery, QueryResult } from '@apollo/client'
import {
  CurrentContractWithCareerPathEvaluationQuery,
  CurrentContractWithCareerPathEvaluationQueryVariables,
  Country,
} from '../../../types'
import { GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION } from '../ContractQueries'

export const useCurrentContractWithCareerPathEvaluation = (
  employeeId: number,
  year: number,
  withChanges: boolean,
  includeAllTargetBoni: boolean,
  country: Country,
): QueryResult<CurrentContractWithCareerPathEvaluationQuery, CurrentContractWithCareerPathEvaluationQueryVariables> => {
  return useQuery<CurrentContractWithCareerPathEvaluationQuery, CurrentContractWithCareerPathEvaluationQueryVariables>(
    GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION,
    {
      variables: {
        employeeId: employeeId,
        year: year,
        withChanges: withChanges,
        includeAllTargetBoni: includeAllTargetBoni,
        country,
      },
      fetchPolicy: 'network-only',
    },
  )
}
